import { setupIonicReact } from '@ionic/react';
import { MobileApp } from '@tbitop/mobile-app';
import { useRouting } from '@tbitop/routing';
import { Modal } from '@tbitop/ui';
import { environment } from '../environments/environment';
import { SalesPlannerGraphQLProvider } from '../infrastructure/graphql/GraphQLProvider';
import '../styles/styles.scss';
import { AppInfo, Datenschutz } from '../ui/controller';
import { PushNotificationsInitializer } from '../ui/controller/push-notification-initializer';
import { Routes } from '../ui/shared/routes';


setupIonicReact();

export const App = () => {

  return (
    <MobileApp
      authenticationConfig={environment.authenticationConfig}
      authorizationConfig={environment.authorizationConfig}
      platformApiUrl={environment.opGraphQLEndpoint}
      telemetryConfig={environment.telemetryConfig}
      appVersionApiUrl={environment.appVersionApiUrl}
    >
      <PushNotificationsInitializer />
      <SalesPlannerGraphQLProvider>
        <Routes />
        <GlobalModals />
      </SalesPlannerGraphQLProvider>
    </MobileApp>
  );
};

const GlobalModals = () => {
  const { query, back } = useRouting();
  const datenschutzOpen = query.datenschutz === '';
  const appInfoOpen = query['app-info'] === '';

  const handleClose = () => back();

  return <>
    <Modal isOpen={datenschutzOpen} onClose={handleClose} size="large" >
      <Datenschutz onClose={handleClose} />
    </Modal>
    <Modal isOpen={appInfoOpen} onClose={handleClose} size="large" >
      <AppInfo onClose={handleClose} />
    </Modal>
  </>;
};
